export const MODAL_PADDING = {
	horizontal: 'px-lg',
	bodyVertical: 'py-lg',
	headerFooterVertical: 'py-lg',
};

export const MODAL_BG_CLASSNAME = 'bg-container-bg';
